import React, { useState } from 'react';
import PageHeader from '../components/layout/PageHeader';
import Button from '../components/ui/Button';
import { UserIcon, BriefcaseIcon, GraduationCapIcon, CalendarIcon, BuildingIcon, AwardIcon, SearchIcon, MailIcon, PhoneIcon } from 'lucide-react';
interface ExcoMember {
  id: string;
  name: string;
  position: string;
  hierarchy: number;
  image: string;
  birthDate?: string;
  education: {
    primary?: string;
    secondary?: string;
    tertiary: string[];
  };
  profession: string;
  bio: string;
  graduationYear: number;
  email?: string;
  phone?: string;
}
const AlumniExcos = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedPosition, setSelectedPosition] = useState<string>('all');
  const excoMembers: ExcoMember[] = [{
    id: '1',
    name: 'Prof. Akintunde Otubu',
    position: 'National President',
    hierarchy: 1,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jn44YtV68i3KkaTAFc7QtH/otubu.png',
    birthDate: '19th September, 1965',
    education: {
      primary: '',
      secondary: 'Isonyin Grammar School',
      tertiary: ['Bachelor of Laws (LL.B) - Obafemi Awolowo University, Ile-Ife, Osun State (1987-1991) - 2nd Class Upper', 'Nigerian Law School, Victoria Island, Lagos (1991-1992) - Called to Nigerian Bar - 2nd Class Upper', 'Master of Laws (LL.M) - University of Lagos, Akoka, Lagos (1995-1996)', 'Master of Philosophy (MPhil) - Obafemi Awolowo University, Ile-Ife, Osun State (2008-2011)', 'Doctor of Philosophy (PhD) - Obafemi Awolowo University, Ile-Ife, Osun State (2011-2015)']
    },
    profession: 'Law Lecturer, Faculty of Law, University of Lagos',
    bio: "Prof. Akintunde Otubu is a distinguished legal scholar and practitioner with over three decades of experience in law. As a Law Lecturer at the Faculty of Law, University of Lagos, he has made significant contributions to legal education and scholarship. He holds a PhD and MPhil from Obafemi Awolowo University, and specializes in Land, Housing, Planning, and Environment Law. Prof. Otubu is a Fellow of the Institute of Security Nigeria and a member of several prestigious professional bodies including the Nigerian Bar Association and Nigerian Association of Law Teachers. As National President of the Isonyin Grammar School Alumni Association, he provides visionary leadership and champions initiatives that enhance the school's development and academic excellence.",
    graduationYear: 1987,
    email: 'president@isonyinalumni.org',
    phone: ''
  }, {
    id: '2',
    name: 'Elder Lanre Oyesile',
    position: 'First Vice President',
    hierarchy: 2,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3Hew6rxsK47JVpej3qfHsv/WhatsApp_Image_2025-11-10_at_20.52.09.jpg',
    birthDate: 'March 23, 1959',
    education: {
      primary: 'Islamic Model Primary School, Mushin, Lagos State',
      secondary: 'Isonyin Grammar School (1981 Set)',
      tertiary: ['OND Printing Technology - Yaba College of Technology']
    },
    profession: 'Entrepreneur & Properties Consultant',
    bio: 'A seasoned professional with a distinguished career in public service and entrepreneurship. Elder Oyesile served with Surulere Local Government until his statutory retirement in 2019. He currently serves as MD/CEO of Larry Jay Properties Consultant, a division of Larry Jay Printers. His extensive experience in both public administration and private enterprise brings valuable leadership to the alumni association.',
    graduationYear: 1981,
    email: '',
    phone: ''
  }, {
    id: '3',
    name: 'Olumide Tayo-Lawal, Esq.',
    position: 'National General Secretary',
    hierarchy: 4,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5aaAcoc7u7GwjzMdDw1BU9/WhatsApp_Image_2025-11-09_at_14.48.47.jpg',
    birthDate: '',
    education: {
      primary: 'Eredo Moslem School, Isonyin/Odosenlu',
      secondary: 'Isonyin Grammar School (1982-1987)',
      tertiary: ['Bachelor of Laws (LL.B) - University of Benin, Benin City, Edo State (graduated 1997)', 'Nigerian Law School, Bwari, Abuja (1999-2000)']
    },
    profession: 'Barrister and Solicitor, Politician, Community Development Advocate',
    bio: 'A native of Odosenlu Alaro in Ijebu North East Local Government of Ogun State, Olumide Tayo-Lawal, Esq. is a distinguished alumnus of Isonyin Grammar School and accomplished legal practitioner. After completing his secondary education at IGS (1982-1987), he proceeded to the University of Benin where he graduated with a Bachelor of Laws degree in 1997. He attended the Nigerian Law School in Bwari, Abuja from 1999 to 2000 and was called to the Nigerian Bar in the year 2000. Since then, he has been in active legal practice while also making significant contributions to politics and community development. As President of the 1982-87 set and now serving as National General Secretary of the Isonyin Grammar School Old Students Association, he remains deeply passionate about the affairs of his alma mater. Married with children, he enjoys travelling, reading, and football. His dedication to both his profession and his community exemplifies the values of leadership and service that IGS instills in its students.',
    graduationYear: 1987
  }, {
    id: '4',
    name: 'SADIQ Adebayo Rasaki',
    position: 'National Treasurer',
    hierarchy: 5,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/w7eCBy2QnBuM2eaUMJCtJK/WhatsApp_Image_2025-11-09_at_12.59.17.jpg',
    birthDate: '13th March, 1966',
    education: {
      primary: 'Christ Church Cathedral School, Broad Street, Lagos',
      secondary: 'Isonyin Grammar School (1978-1983)',
      tertiary: ["GCE 'A' Level - King's College Annexe (Formerly Federal School of Arts & Science)", 'B.Sc (Special Hons) in Microbiology - University of Lagos (1988)', 'Entrepreneurship Training - FATE Foundation']
    },
    profession: 'Agripreneur - CEO of SADIQ RESOURCES LIMITED & BAYOOR SADIQ FARMS',
    bio: 'A prolific entrepreneur and distinguished alumnus of Isonyin Grammar School, SADIQ Adebayo Rasaki has built an impressive career spanning corporate and entrepreneurial ventures. After graduating with honors in Microbiology from the University of Lagos, he began his professional journey at DIL(Maltex)PLC, a subsidiary of CFAO(Nig)PLC in 1989. He further honed his skills at Godfrey Konu & Co, a firm of Chartered Accountants, before pursuing entrepreneurship training at the prestigious FATE Foundation. Today, he leads SADIQ RESOURCES LIMITED and BAYOOR SADIQ FARMS as a successful agripreneur, demonstrating the entrepreneurial spirit and excellence fostered at IGS.',
    graduationYear: 1983
  }, {
    id: '5',
    name: 'Abimbola Taiwo Olarewaju',
    position: 'National Financial Secretary',
    hierarchy: 6,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xoPZ5CeiJfFxam6WebTFFc/WhatsApp_Image_2025-11-09_at_14.37.11.jpg',
    birthDate: '22nd June, 1961',
    education: {
      primary: 'Primary education',
      secondary: 'Isonyin Grammar School (1973-1978)',
      tertiary: ['B.Sc in Accounting']
    },
    profession: 'Educational Consultant, Co-op Administrator, Retired Deputy Director (Lagos State PP-TESCOM)',
    bio: 'Abimbola Taiwo Olarewaju is a seasoned educator and administrator who has dedicated his career to the advancement of education in Lagos State. A distinguished member of the 1973-78 set, he earned his B.Sc in Accounting and built an impressive career in education administration, rising to the position of Deputy Director with Lagos State PP-TESCOM (Teaching Service Commission) before his retirement. Throughout his career, he has been recognized as a seasoned tutor with a passion for nurturing young minds. Currently, he serves as an Educational Consultant and Co-op Administrator, continuing to contribute his wealth of experience to the education sector. His appointment as National Financial Secretary of the Isonyin Grammar School Alumni Association reflects his strong financial acumen and commitment to the development of his alma mater.',
    graduationYear: 1978
  }, {
    id: '6',
    name: 'Yeye Adesola Salami',
    position: 'Publicity Secretary',
    hierarchy: 7,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gDiHx8kfPCYtVcBF6agkJD/WhatsApp_Image_2025-11-09_at_14.33.59.jpg',
    birthDate: '15th August, 1968',
    education: {
      primary: 'Primary education in Isonyin, Ijebu',
      secondary: 'Isonyin Grammar School',
      tertiary: ['Nigeria Institute of Journalism, Lagos']
    },
    profession: 'Media Professional, Publisher, Community Development Advocate',
    bio: 'Faozat Adesola Salami, known as Yeye Adesola Salami, is a multifaceted personality and experienced media professional with expertise in print and electronic media. An indigene of Isonyin, Ijebu in Ijebu North East Local Government, Ogun State, she was born at Lagos State University Teaching Hospital, Idiaraba Lagos. As former President of the Students Union Government at Nigeria Institute of Journalism and former Chairperson of the National Association of Women Journalists (NAWOJ) Ondo State Chapter, she has demonstrated exceptional leadership throughout her career. She is the publisher of Style Network Magazine, which will soon transition to an online Personality Magazine, and served as General Manager of Vicinity 95.3fm, Ikeji Ile, Ijesa, Osun State. Currently, she serves as Project Director of MASA Isonyin Marathon, promoting youth empowerment, community development, and healthy living. In recognition of her significant contributions to her community, she was installed as the Yeroyin of Isonyin land. A passionate advocate for peace and community development, she is also an enthusiast of tourism, arts, and culture. Yeye Adesola Salami is known as a strict, loyal, and loving individual, and is a proud mother and grandmother.',
    graduationYear: 1986
  }, {
    id: '7',
    name: 'Olamide Adesola Oyenuga',
    position: 'Assistant General Secretary',
    hierarchy: 8,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nR1xAQu1SrTC6snxzfQ7dJ/image.png',
    birthDate: '',
    education: {
      primary: '',
      secondary: '',
      tertiary: ['Bachelor of Education in Agriculture - Tai-Solarin University of Education, Ijagun, Ijebu-Ode, Ogun State (2007)']
    },
    profession: 'Education Sector Professional',
    bio: 'A dynamic leader in the education sector with 13 years of diverse experience in both elementary and colleges. With a proven track record in strategic planning, initiatives and program development that enhance educational excellence and continuous improvement. Her areas of expertise include strategic planning, educational excellence, program development, continuous improvement, community service, networking, and time management.',
    graduationYear: 2007,
    email: 'odeymideo@gmail.com',
    phone: '08037268479'
  }, {
    id: '8',
    name: 'Orepekan Kehinde Adewale',
    position: 'National Social Director',
    hierarchy: 9,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4BW49KtAwcy4acgofnGhtA/1000770229.jpg',
    birthDate: '',
    education: {
      primary: '',
      secondary: 'Isonyin Grammar School',
      tertiary: ['NCE (Chemistry/Mathematics) - Lagos State College of Education', 'BSc (Science Education Mathematics) - Anambra State University of Science and Technology, Enugu', 'Masters (Personnel Psychology HR) - Ogun State University, Ago Iwoye']
    },
    profession: 'Education & Human Resources Professional',
    bio: 'A distinguished educator and human resources professional with extensive academic qualifications spanning chemistry, mathematics, science education, and personnel psychology. His diverse educational background from multiple prestigious institutions has equipped him with a unique blend of scientific knowledge and human resources expertise, making him an invaluable asset in fostering social cohesion and community engagement within the alumni association.',
    graduationYear: 0,
    email: '',
    phone: ''
  }];
  // Sort members by hierarchy
  const sortedMembers = [...excoMembers].sort((a, b) => a.hierarchy - b.hierarchy);
  // Filter members based on search and position
  const filteredMembers = sortedMembers.filter(member => {
    const matchesSearch = member.name.toLowerCase().includes(searchQuery.toLowerCase()) || member.position.toLowerCase().includes(searchQuery.toLowerCase()) || member.profession.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesPosition = selectedPosition === 'all' || member.position === selectedPosition;
    return matchesSearch && matchesPosition;
  });
  // Get unique positions for filter
  const positions = ['all', ...new Set(excoMembers.map(m => m.position))];
  return <div className="min-h-screen bg-gray-50" data-id="element-2361">
      <PageHeader title="Alumni Executive Committee" description="Meet the dedicated leaders guiding the Isonyin Grammar School Alumni Association" backgroundImage="https://uploadthingy.s3.us-west-1.amazonaws.com/bZLbes2hxk7MhXzaZ1hXLV/WhatsApp_Image_2025-10-24_at_10.01.19.jpg" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'Alumni',
      path: '/alumni'
    }, {
      label: 'Executive Committee',
      path: '/alumni/excos'
    }]} data-id="element-2362" />
      <div className="container mx-auto px-4 py-12" data-id="element-2363">
        {/* Introduction Section */}
        <div className="text-center mb-12" data-id="element-2364">
          <h2 className="text-3xl font-bold text-blue-900 mb-3" data-id="element-2365">
            Our Leadership Team
          </h2>
          <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-2366"></div>
          <p className="mt-4 text-gray-600 max-w-3xl mx-auto" data-id="element-2367">
            The Alumni Executive Committee comprises dedicated volunteers who
            work tirelessly to strengthen the bonds among IGS alumni, support
            the school's development, and create opportunities for networking
            and giving back to our alma mater.
          </p>
        </div>
        {/* Search and Filter Section */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-8" data-id="element-2368">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2369">
            <div className="relative" data-id="element-2370">
              <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" data-id="element-2371" />
              <input type="text" placeholder="Search by name, position, or profession..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-2372" />
            </div>
            <select value={selectedPosition} onChange={e => setSelectedPosition(e.target.value)} className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-2373">
              {positions.map(position => <option key={position} value={position} data-id="element-2374">
                  {position === 'all' ? 'All Positions' : position}
                </option>)}
            </select>
          </div>
          <div className="mt-4 text-sm text-gray-600" data-id="element-2375">
            Showing {filteredMembers.length} of {excoMembers.length} members
          </div>
        </div>
        {/* Quick Navigation */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-8" data-id="element-2376">
          <h3 className="text-lg font-bold text-blue-900 mb-4" data-id="element-2377">
            Quick Navigation
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3" data-id="element-2378">
            {sortedMembers.map(member => <a key={member.id} href={`#member-${member.id}`} className="text-sm text-blue-700 hover:text-blue-900 hover:underline text-center p-2 rounded-lg hover:bg-blue-50 transition-colors" data-id="element-2379">
                {member.position}
              </a>)}
          </div>
        </div>
        {/* Executive Committee Members */}
        <div className="space-y-8" data-id="element-2380">
          {filteredMembers.map((member, index) => <div key={member.id} id={`member-${member.id}`} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow scroll-mt-24" data-id="element-2381">
              <div className="md:flex" data-id="element-2382">
                {/* Photo Section */}
                <div className="md:w-1/3 bg-gradient-to-br from-blue-900 to-blue-700 p-6 md:p-8 flex items-center justify-center" data-id="element-2383">
                  <div className="text-center w-full" data-id="element-2384">
                    <div className="mb-4" data-id="element-2385">
                      <img src={member.image} alt={member.name} className="w-48 h-48 md:w-56 md:h-56 rounded-lg object-cover mx-auto shadow-xl border-4 border-white" data-id="element-2386" />
                    </div>
                    <div className="bg-yellow-500 text-blue-900 px-4 py-2 rounded-full font-bold text-sm md:text-base shadow-md inline-block" data-id="element-2387">
                      {member.position}
                    </div>
                    {member.hierarchy === 1 && <div className="mt-3 bg-white/20 backdrop-blur-sm text-white px-3 py-1 rounded-full text-xs font-semibold inline-block" data-id="element-2388">
                        Chief Executive
                      </div>}
                  </div>
                </div>
                {/* Details Section */}
                <div className="md:w-2/3 p-6 md:p-8" data-id="element-2389">
                  <div className="flex items-start justify-between mb-4" data-id="element-2390">
                    <h2 className="text-2xl md:text-3xl font-bold text-blue-900" data-id="element-2391">
                      {member.name}
                    </h2>
                    <span className="bg-blue-100 text-blue-900 px-3 py-1 rounded-full text-xs font-semibold" data-id="element-2392">
                      #{index + 1}
                    </span>
                  </div>
                  {/* Quick Info Grid */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-6" data-id="element-2393">
                    {member.birthDate && <div className="flex items-center text-sm text-gray-700 bg-gray-50 p-3 rounded-lg" data-id="element-2394">
                        <CalendarIcon className="h-4 w-4 mr-2 text-blue-700 flex-shrink-0" data-id="element-2395" />
                        <span data-id="element-2396">
                          <strong data-id="element-2397">Born:</strong> {member.birthDate}
                        </span>
                      </div>}
                    <div className="flex items-center text-sm text-gray-700 bg-gray-50 p-3 rounded-lg" data-id="element-2398">
                      <GraduationCapIcon className="h-4 w-4 mr-2 text-blue-700 flex-shrink-0" data-id="element-2399" />
                      <span data-id="element-2400">
                        <strong data-id="element-2401">IGS Alumni</strong>
                      </span>
                    </div>
                    <div className="flex items-start text-sm text-gray-700 bg-gray-50 p-3 rounded-lg sm:col-span-2" data-id="element-2402">
                      <BriefcaseIcon className="h-4 w-4 mr-2 text-blue-700 flex-shrink-0 mt-0.5" data-id="element-2403" />
                      <span data-id="element-2404">
                        <strong data-id="element-2405">Profession:</strong> {member.profession}
                      </span>
                    </div>
                  </div>
                  {/* Bio */}
                  <div className="mb-6" data-id="element-2406">
                    <h3 className="text-lg font-bold text-blue-900 mb-2 flex items-center" data-id="element-2407">
                      <UserIcon className="h-5 w-5 mr-2" data-id="element-2408" />
                      Biography
                    </h3>
                    <p className="text-gray-700 leading-relaxed text-sm md:text-base" data-id="element-2409">
                      {member.bio}
                    </p>
                  </div>
                  {/* Educational Background */}
                  <details className="group mb-6" open data-id="element-2410">
                    <summary className="cursor-pointer" data-id="element-2411">
                      <h3 className="text-lg font-bold text-blue-900 mb-3 flex items-center inline" data-id="element-2412">
                        <GraduationCapIcon className="h-5 w-5 mr-2" data-id="element-2413" />
                        Educational Background
                      </h3>
                    </summary>
                    <div className="space-y-3 mt-3" data-id="element-2414">
                      {member.education.primary && <div className="bg-blue-50 p-3 rounded-lg border border-blue-100" data-id="element-2415">
                          <h4 className="font-semibold text-blue-900 mb-1 text-sm" data-id="element-2416">
                            Primary Education
                          </h4>
                          <p className="text-gray-700 text-sm" data-id="element-2417">
                            {member.education.primary}
                          </p>
                        </div>}
                      {member.education.secondary && <div className="bg-blue-50 p-3 rounded-lg border border-blue-100" data-id="element-2418">
                          <h4 className="font-semibold text-blue-900 mb-1 text-sm" data-id="element-2419">
                            Secondary Education
                          </h4>
                          <p className="text-gray-700 text-sm" data-id="element-2420">
                            {member.education.secondary}
                          </p>
                        </div>}
                      <div className="bg-blue-50 p-3 rounded-lg border border-blue-100" data-id="element-2421">
                        <h4 className="font-semibold text-blue-900 mb-2 text-sm" data-id="element-2422">
                          Tertiary Education
                        </h4>
                        <ul className="space-y-2" data-id="element-2423">
                          {member.education.tertiary.map((edu, eduIndex) => <li key={eduIndex} className="flex items-start" data-id="element-2424">
                              <div className="flex-shrink-0 h-2 w-2 rounded-full bg-blue-700 mt-1.5 mr-2" data-id="element-2425"></div>
                              <span className="text-gray-700 text-sm" data-id="element-2426">
                                {edu}
                              </span>
                            </li>)}
                        </ul>
                      </div>
                    </div>
                  </details>
                  {/* Professional Qualifications - Only for National President */}
                  {member.hierarchy === 1 && <details className="group mb-6" open data-id="element-2427">
                      <summary className="cursor-pointer" data-id="element-2428">
                        <h3 className="text-lg font-bold text-blue-900 mb-3 flex items-center inline" data-id="element-2429">
                          <AwardIcon className="h-5 w-5 mr-2" data-id="element-2430" />
                          Professional Qualifications & Memberships
                        </h3>
                      </summary>
                      <div className="bg-blue-50 p-4 rounded-lg border border-blue-100 mt-3" data-id="element-2431">
                        <ul className="space-y-2" data-id="element-2432">
                          <li className="flex items-start" data-id="element-2433">
                            <div className="flex-shrink-0 h-2 w-2 rounded-full bg-blue-700 mt-1.5 mr-2" data-id="element-2434"></div>
                            <span className="text-gray-700 text-sm" data-id="element-2435">
                              <strong data-id="element-2436">1992:</strong> Barrister and Solicitor,
                              Supreme Court of Nigeria
                            </span>
                          </li>
                          <li className="flex items-start" data-id="element-2437">
                            <div className="flex-shrink-0 h-2 w-2 rounded-full bg-blue-700 mt-1.5 mr-2" data-id="element-2438"></div>
                            <span className="text-gray-700 text-sm" data-id="element-2439">
                              <strong data-id="element-2440">2000:</strong> Member, National Institute
                              of Marketing Nigeria
                            </span>
                          </li>
                          <li className="flex items-start" data-id="element-2441">
                            <div className="flex-shrink-0 h-2 w-2 rounded-full bg-blue-700 mt-1.5 mr-2" data-id="element-2442"></div>
                            <span className="text-gray-700 text-sm" data-id="element-2443">
                              <strong data-id="element-2444">2016:</strong> Fellow, Institute of
                              Security Nigeria
                            </span>
                          </li>
                          <li className="flex items-start" data-id="element-2445">
                            <div className="flex-shrink-0 h-2 w-2 rounded-full bg-blue-700 mt-1.5 mr-2" data-id="element-2446"></div>
                            <span className="text-gray-700 text-sm" data-id="element-2447">
                              Member, Nigerian Bar Association
                            </span>
                          </li>
                          <li className="flex items-start" data-id="element-2448">
                            <div className="flex-shrink-0 h-2 w-2 rounded-full bg-blue-700 mt-1.5 mr-2" data-id="element-2449"></div>
                            <span className="text-gray-700 text-sm" data-id="element-2450">
                              Member, Nigerian Association of Law Teachers
                            </span>
                          </li>
                          <li className="flex items-start" data-id="element-2451">
                            <div className="flex-shrink-0 h-2 w-2 rounded-full bg-blue-700 mt-1.5 mr-2" data-id="element-2452"></div>
                            <span className="text-gray-700 text-sm" data-id="element-2453">
                              Member, Ijebu ode Club (1921)
                            </span>
                          </li>
                          <li className="flex items-start" data-id="element-2454">
                            <div className="flex-shrink-0 h-2 w-2 rounded-full bg-blue-700 mt-1.5 mr-2" data-id="element-2455"></div>
                            <span className="text-gray-700 text-sm" data-id="element-2456">
                              Member, Gregarious Club Nigeria
                            </span>
                          </li>
                          <li className="flex items-start" data-id="element-2457">
                            <div className="flex-shrink-0 h-2 w-2 rounded-full bg-blue-700 mt-1.5 mr-2" data-id="element-2458"></div>
                            <span className="text-gray-700 text-sm" data-id="element-2459">
                              Patron, Mahdiyat Islamic Youths Association of
                              Nigeria
                            </span>
                          </li>
                        </ul>
                        <div className="mt-4 pt-4 border-t border-blue-200" data-id="element-2460">
                          <h4 className="font-semibold text-blue-900 mb-2 text-sm" data-id="element-2461">
                            Area of Specialization
                          </h4>
                          <p className="text-gray-700 text-sm" data-id="element-2462">
                            Land, Housing, Planning, and Environment Law
                          </p>
                        </div>
                      </div>
                    </details>}
                  {/* Professional Role Highlight */}
                  <div className="bg-gradient-to-r from-yellow-50 to-yellow-100 p-4 rounded-lg border border-yellow-200" data-id="element-2463">
                    <h3 className="text-base font-bold text-blue-900 mb-2 flex items-center" data-id="element-2464">
                      <BuildingIcon className="h-4 w-4 mr-2" data-id="element-2465" />
                      Current Professional Role
                    </h3>
                    <p className="text-gray-700 text-sm" data-id="element-2466">{member.profession}</p>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
        {/* No Results Message */}
        {filteredMembers.length === 0 && <div className="text-center py-12" data-id="element-2467">
            <p className="text-gray-600 text-lg" data-id="element-2468">
              No members found matching your search criteria.
            </p>
            <button onClick={() => {
          setSearchQuery('');
          setSelectedPosition('all');
        }} className="mt-4 text-blue-700 hover:text-blue-900 font-medium" data-id="element-2469">
              Clear filters
            </button>
          </div>}
        {/* Executive Structure Overview */}
        <div className="mt-12 bg-blue-900 text-white p-6 md:p-8 rounded-lg" data-id="element-2470">
          <h2 className="text-xl md:text-2xl font-bold mb-6 text-center" data-id="element-2471">
            Alumni Association Executive Structure
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-2472">
            <div className="bg-yellow-500 p-4 md:p-6 rounded-lg" data-id="element-2473">
              <div className="text-center" data-id="element-2474">
                <div className="inline-block p-3 md:p-4 rounded-full bg-blue-900/20 mb-3 md:mb-4" data-id="element-2475">
                  <UserIcon className="h-6 w-6 md:h-8 md:w-8 text-blue-900" data-id="element-2476" />
                </div>
                <h3 className="text-lg md:text-xl font-bold text-blue-900 mb-2" data-id="element-2477">
                  National President
                </h3>
                <p className="text-xs md:text-sm text-blue-900" data-id="element-2478">
                  Provides overall leadership and strategic direction
                </p>
              </div>
            </div>
            <div className="bg-blue-800/50 p-4 md:p-6 rounded-lg backdrop-blur-sm border border-blue-700/50" data-id="element-2479">
              <div className="text-center" data-id="element-2480">
                <div className="inline-block p-3 md:p-4 rounded-full bg-yellow-500/20 mb-3 md:mb-4" data-id="element-2481">
                  <UserIcon className="h-6 w-6 md:h-8 md:w-8 text-yellow-400" data-id="element-2482" />
                </div>
                <h3 className="text-lg md:text-xl font-bold mb-2" data-id="element-2483">
                  Vice Presidents
                </h3>
                <p className="text-xs md:text-sm text-blue-200" data-id="element-2484">
                  Support the president and manage key initiatives
                </p>
              </div>
            </div>
            <div className="bg-blue-800/50 p-4 md:p-6 rounded-lg backdrop-blur-sm border border-blue-700/50" data-id="element-2485">
              <div className="text-center" data-id="element-2486">
                <div className="inline-block p-3 md:p-4 rounded-full bg-yellow-500/20 mb-3 md:mb-4" data-id="element-2487">
                  <BriefcaseIcon className="h-6 w-6 md:h-8 md:w-8 text-yellow-400" data-id="element-2488" />
                </div>
                <h3 className="text-lg md:text-xl font-bold mb-2" data-id="element-2489">
                  Executive Officers
                </h3>
                <p className="text-xs md:text-sm text-blue-200" data-id="element-2490">
                  Manage day-to-day operations and specific portfolios
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Call to Action */}
        <div className="mt-12 bg-gradient-to-r from-yellow-500 to-yellow-400 p-6 md:p-8 rounded-lg text-center" data-id="element-2491">
          <h2 className="text-xl md:text-2xl font-bold text-blue-900 mb-4" data-id="element-2492">
            Get Involved with the Alumni Association
          </h2>
          <p className="text-blue-900 mb-6 max-w-2xl mx-auto text-sm md:text-base" data-id="element-2493">
            Join your fellow alumni in supporting IGS and staying connected. The
            executive committee welcomes your participation and contributions.
          </p>
          <div className="flex flex-wrap justify-center gap-4" data-id="element-2494">
            <Button href="/alumni/join" variant="primary" size="lg" data-id="element-2495">
              Join Alumni Association
            </Button>
            <Button href="/alumni" variant="outline" size="lg" className="border-blue-900 text-blue-900 hover:bg-blue-900/10" data-id="element-2496">
              Back to Alumni Page
            </Button>
          </div>
        </div>
      </div>
    </div>;
};
export default AlumniExcos;